'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import { Breadcrumbs } from '@/components/ui/Breadcrumbs/Breadcrumbs';

import styles from './RepairDetailsPageChrome.module.scss';

interface RepairDetailsPageChromeProps {
  children: ReactNode;
}

export function RepairDetailsPageChrome({ children }: Readonly<RepairDetailsPageChromeProps>) {
  const t = useTranslations('service.repairDetails');
  const tBreadcrumbs = useTranslations('breadcrumbs');

  return (
    <div className={styles.page}>
      <div className={styles.hero} data-testid="RepairDetailsPageChrome">
        <div className={clsx('container', styles.heroTop)}>
          <Breadcrumbs
            variant="pageHeader"
            title={t('pageTitle')}
            items={[
              { label: tBreadcrumbs('home'), href: '/' },
              { label: t('breadcrumbs.services'), href: '/service/request' },
            ]}
            appearance="cta"
            noPadding
            className={styles.breadcrumbs}
            testId="RepairDetailsPageTitle"
          />
        </div>
      </div>
      {children}
    </div>
  );
}
